import { ComponentKind, TableGlideType, MutatingScreenKind, PropertyKind } from "../description";
import { ToggleComponentHandler, ToggleComponentDescription } from "./toggle";
import { ComponentConfiguratorContext, ComponentDescriptor, PropertyDescriptor } from ".";
import { PropertySection } from "./property-sections";

const ComponentKindCheckbox: ComponentKind = "checkbox";

export class CheckboxComponentHandler extends ToggleComponentHandler {
    constructor() {
        super(ComponentKindCheckbox, ["flag", "checkbox"]);
    }

    protected readonly name = "Checkbox";
    protected readonly description = "A box you can check";
    protected readonly img = "componentCheckbox";
    protected readonly docPath = "toggle";

    protected readonly uiName = "Checkbox";

    public getDescriptor(
        desc: ToggleComponentDescription,
        table: TableGlideType | undefined,
        ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ComponentDescriptor<ToggleComponentDescription> {
        const baseDescriptor = super.getDescriptor(desc, table, ccc, mutatingScreenKind);
        const checkboxProperties: readonly PropertyDescriptor[] =
            mutatingScreenKind === undefined
                ? baseDescriptor.properties
                : [
                      ...baseDescriptor.properties,
                      {
                          kind: PropertyKind.Switch,
                          property: { name: "mustBeActive" },
                          label: "Required",
                          section: PropertySection.Options,
                      },
                  ];
        return {
            ...baseDescriptor,
            properties: checkboxProperties,
        };
    }
}
